import React from "react";

const MessengerIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Messenger"
      role="img"
      viewBox="80 70 370 350"
      height={size}
      width={size}
    >
      <rect height={size} width={size} rx="15%" fill={color} />
      <linearGradient
        id="a"
        x1="256"
        x2="256"
        y1="78.2"
        y2="441.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00B2FF" />
        <stop offset="1" stopColor="#006AFF" />
      </linearGradient>
      <path
        fill="url(#a)"
        d="M256 78.2c-102.4 0-181.8 75 -181.8 176.4c0 53 21.7 98.8 57 130.4a14.7 14.7 0 015 10.4l1 32.3a14.6 14.6 0 0020.4 12.9l36-16a14.5 14.5 0 019.8-.7a197.8 197.8 0 0052.6 7c102.4 0 181.8-75 181.8 -176.3S358.4 78.2 256 78.2z"
      />
      <path
        fill="#ffffff"
        d="M146.8 306.1l53.4-84.7a27.3 27.3 0 0139.5-7.3l42.5 31.9a11 11 0 0013 0l57.5-43.6c7.6-5.8 17.6 3.4 12.5 11.5l-53.4 84.7a27.3 27.3 0 01-39.4 7.3L229.9 274a11 11 0 00-13.2 0l-57.4 43.6c-7.6 5.8-17.6 -3.4 -12.5 -11.5z"
      />
    </svg>
  );
};

export default MessengerIcon;
